import type React from 'react';
import EventCalendarCard, { type EventCalendarCardProps } from './EventCalendarCard';
import { toEpochMs } from '../EventCalendarHelpers';

export interface EventCalendarEventsProps {
    events: EventCalendarCardProps[];
}

const Events: React.FC<EventCalendarEventsProps> = ({ events }) => {
    const sortedEvents = [...events].sort((a, b) => {
        const aPriority = a.tagLabel && a.tagLabel.length > 0;
        const bPriority = b.tagLabel && b.tagLabel.length > 0;

        if (aPriority && !bPriority) {
            return -1;
        }
        if (!aPriority && bPriority) {
            return 1;
        }

        // If both are priority or both are not, sort by date
        return toEpochMs(a.date) - toEpochMs(b.date);
    });

    // Don't render anything if there are no events
    if (sortedEvents.length === 0) {
        return null;
    }

    return (
        <ul className="events">
            {sortedEvents.map(event => {
                return (
                    <EventCalendarCard
                        key={`${event.url}-${event.title}-${event.date}`}
                        {...event} // eslint-disable-line react/jsx-props-no-spreading
                    />
                );
            })}
        </ul>
    );
};

export default Events;
